import { RootState } from 'app/rootReducer';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { addRooms } from './houseSlice';

export default function ElInstall(): JSX.Element{

    let house = useSelector(
        (state: RootState) => state.house
    )

    const elInfo: {[key: number]: any} = {
        0: {
            info: 'Det skal installeres minst to uttak pr. påbegynt 4 m^2 gulvareal',
            m2Check: 4,
            uttak: 2,
            name: "Stue",
        },
        1: {
            info: 'Det skal installeres minst to uttak pr. påbegynt 4 m^2 gulvareal',
            m2Check: 4,
            uttak: 2,
            name: "Soverom",
        },
        2: {
            info: 'Det skal installeres minst to uttak pr. påbegynt 4 m^2 gulvareal',
            m2Check: 4,
            uttak: 2,
            name: "Arbeidsrom",
        },
        3: {
            info: 'Det skal installeres minst to uttak pr. påbegynt 4 m^2 gulvareal',
            m2Check: 4,
            uttak: 2,
            name: "Oppholdsrom",
        },
        4: {
            info: 'Det skal monteres minimum: ett uttak for hvert faste elektrisk utstyr (kjøl, frys, stekeovn, komfyrtopp, ventilator, kaffemaskin, mikrobølgeovn mv.), og to uttak per 2m kjøkkenbenk for tilkobling av kjøkkenmaskiner mv., og 4 uttak i forbindelse med spiseplass, men ikke mindre enn to uttak per. 2m fri vegg.',
            mBenkVegg: 2,
            uttakBenkVegg: 2,
            uttakSpis: 4,
            name: "Kjøkken",
        },
        5: {
            info: 'Det skal monteres minimum to uttak pr. påbegynt 6m^2 gulvareal.',
            m2Check: 6,
            uttak: 2,
            name: "Entre/Gang",
        },
        6: {
            info: 'For stasjonært utstyr som er planlagt plassert i slike rom, skal det monteres dedikert uttak, med mindre utstyret er fast tilkoblet. I rommet forøvrig skal det monteres minst to uttak, med mindre rommets areal er < 3m^2 hvor det aksepteres ett uttak.',
            m2Check: 3,
            uttak: 2,
            name: "Bad/WC/Vaskerom",
        },
        7: {
            info: 'Det skal monteres det nødvendige antall uttak tilpasset rommets funksjon, men ikke færre enn to uttak',
            uttak: 2,
            name: "Andre Rom/Boder",
        },
        8: {
            info: 'På en veranda /altan/balkong skal det monteres minimum to uttak. Utvendige uttak forøvrig skal tilpasses boligens utforming og planlagte bruk.',
            uttak: 2,
            name: "Utvendig"
        },
    }
    const room: {[key: string]: any} = house.rooms[house.currentRoom]
    let loopRoom = [{...room}]
    const dispatch = useDispatch()

    let elValues = {...room["elInstall"]}
    console.log(elValues)
    let audio = elValues.audio;
    let square = elValues.roomSize;
    let wall = elValues.wallSize;
    let equip = elValues.equipmentAmount;
    let bench = elValues.benchSize
    
    function StoreElInstall(){
        let roomList = house.rooms
        let newList = roomList.map((list, i) => {
            if (i !== house.currentRoom) return list;
            return{
                ...list, elInstall: elValues
            }
        })
        console.log(newList)
        dispatch(addRooms(newList))
    }

    function calculateMinimum(selRoom: number){
        let calcAmount = 0
        switch (selRoom) {
            case 4:
                calcAmount += equip;
                calcAmount += (Math.ceil(bench / elInfo[selRoom].mBenkVegg)) * elInfo[selRoom].uttakBenkVegg;
                calcAmount += (Math.ceil(wall / elInfo[selRoom].mBenkVegg)) * elInfo[selRoom].uttakBenkVegg;
                calcAmount += elValues.eatingArea ? elInfo[selRoom].uttakSpis : 0;
                calcAmount += audio ? 6 : 0;
                break;
            case 6:
                calcAmount += square < elInfo[selRoom].m2Check ? 1 : 2;
                break;
            case 7:
                console.log(elInfo[selRoom].uttak)
                calcAmount += elInfo[selRoom].uttak;
                calcAmount += audio ? 6 : 0;
                break;
            case 8:
                console.log(elInfo[selRoom].uttak)
                calcAmount += elInfo[selRoom].uttak;
                calcAmount += audio ? 6 : 0;
                break;
            default:
                console.log(Math.ceil(square / elInfo[selRoom].m2Check))
                console.log(square)
                console.log(square / elInfo[selRoom].m2Check)
                calcAmount += (Math.ceil(square / elInfo[selRoom].m2Check))  * elInfo[selRoom].uttak;
                calcAmount += audio ? 6 : 0;                
                break;
        }
        elValues.needAmount = calcAmount;
        elValues.roomType = selRoom;
        elValues.roomSize = square;
        elValues.equipmentAmount = equip
        elValues.wallSize = wall;
        elValues.benchSize = bench;
        elValues.audio = audio;
        elValues.roomName = elInfo[selRoom].name;
        StoreElInstall();
    }

    function calculateTotal(){
        let calcAmount = parseInt(elValues.singleStick); 
        calcAmount += parseInt(elValues.doubleStick) * 2
        calcAmount += parseInt(elValues.fourWayStick) * 4;
        elValues.totalAmount = calcAmount;
        StoreElInstall();
    }
    console.log(loopRoom)

    return(
        <div className="mainDiv">
            {loopRoom.map((v,i) => (
                <div>
                    <h3>Stikk informasjon</h3>
                <select value={v.elInstall.roomType} onChange={(event) => {calculateMinimum(parseInt(event.currentTarget.value))}}>
                    <option value="0">Stue</option>
                    <option value="1">Soverom</option>
                    <option value="2">Arbeidsrom</option>
                    <option value="3">Oppholdsrom</option>
                    <option value="4">Kjøkken</option>
                    <option value="5">Entre/Gang</option>
                    <option value="6">Bad/WC/Vaskerom</option>
                    <option value="7">Andre Rom/Boder</option>
                    <option value="8">Utvendig</option>
                </select>

                <p>{elInfo[v.elInstall.roomType].info}</p>
                
                <hr />

                <input 
                    type="checkbox"
                    id="chkAudio"
                    checked={v.elInstall.audio}
                    onChange={(event) => {
                            audio = event.currentTarget.checked; 
                            calculateMinimum(elValues.roomType);
                        }
                    }
                />
                <label 
                    htmlFor="chkAudio" 
                    className="chkBoxLabel"
                >Flere audiovisuelle enheter Eks: TV</label>

                <div style={{display: v.elInstall.roomType === 4 ? 'none' : 'initial'}}>
                    <p className="highlightText">Størrelse på rommet (m^2):</p>
                    <input 
                        type="number" 
                        min="0" 
                        value={v.elInstall.roomSize} 
                        onChange={(event) => {
                            square = isNaN(parseInt(event.currentTarget.value))
                                ? 0
                                : parseInt(event.currentTarget.value)
                            ;
                            console.log(isNaN(parseInt(event.currentTarget.value)));
                            calculateMinimum(elValues.roomType)}
                        } 
                    />
                </div>

                <div style={{display: v.elInstall.roomType === 4 ? 'initial' : 'none'}}>
                    <p className="highlightText">Antall meter kjøkkenbenk:</p>
                    <input 
                        type="number" 
                        min="0"
                        value={v.elInstall.benchSize}
                        onChange={(event) => {
                            bench = isNaN(parseInt(event.currentTarget.value))
                                ? 0
                                : parseInt(event.currentTarget.value)
                            ; 
                            calculateMinimum(elValues.roomType)}
                        }
                    />
                    <p className="highlightText">Antall fast elektrisk utstyr (kjøl, stekeovn osv...):</p>
                    <input 
                        type="number" 
                        min="0" 
                        value={v.elInstall.equipmentAmount} 
                        onChange={(event) => {
                            equip =  isNaN(parseInt(event.currentTarget.value))
                                ? 0
                                : parseInt(event.currentTarget.value)
                            ;
                            calculateMinimum(elValues.roomType)}
                        }
                    />
                    <p className="highlightText">Antall meter fri vegg:</p>
                    <input 
                        type="number" 
                        min="0" 
                        value={v.elInstall.wallSize} 
                        onChange={(event) => {
                            wall = isNaN(parseInt(event.currentTarget.value))
                                ? 0
                                : parseInt(event.currentTarget.value)
                            ; 
                            calculateMinimum(elValues.roomType)}
                        } 
                    /><br />
                    
                    <input 
                        type="checkbox" 
                        id="chkSpis"
                        checked={v.elInstall.eatingArea}
                        onChange={(event) => {
                            elValues.eatingArea = event.currentTarget.checked; 
                            calculateMinimum(elValues.roomType)}}
                    /><label htmlFor="chkSpis" className="chkBoxLabel">Spiseplass?</label>
                </div>
                
                
                <p>Minimum antall utganger er: {elValues.needAmount}</p>

                <p className="highlightText">Enkle Uttak:</p>
                <input 
                    type="number" 
                    min="0"
                    value={v.elInstall.singleStick}
                    onChange={(event) => {
                        console.log(event.currentTarget.value);
                        elValues.singleStick = isNaN(parseInt(event.currentTarget.value))
                            ? 0
                            : parseInt(event.currentTarget.value)
                        ;
                        calculateTotal();
                    }}
                />
                <p className="highlightText">Dobble Uttak:</p>
                <input 
                    type="number" 
                    min="0"
                    value={v.elInstall.doubleStick}
                    onChange={(event) => {
                        console.log(event.currentTarget.value);
                        elValues.doubleStick = isNaN(parseInt(event.currentTarget.value))
                            ? 0
                            : parseInt(event.currentTarget.value)
                        ; 
                        calculateTotal();
                    }}
                />
                <p className="highlightText">4-veis Uttak:</p>
                <input 
                    type="number" 
                    min="0"
                    value={v.elInstall.fourWayStick}
                    onChange={(event) => {
                        console.log(event.currentTarget.value);
                        elValues.fourWayStick = isNaN(parseInt(event.currentTarget.value))
                            ? 0
                            : parseInt(event.currentTarget.value)
                        ; 
                        calculateTotal();
                    }}
                />
                <hr />
                <p className="highlightText">Totalt antall stikker: {elValues.totalAmount}</p>

            </div>
            ))}
        </div>
    )
}